import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme, keyframes } from '@mui/material/styles';
import NRRiseAiChatDrawer from './NRRiseAiChatDrawer';
import NRRiseAIMorphIcon from './components/NRRiseAIMorphIcon';
import NRRiseAIAnimatedBorder from './components/NRRiseAIAnimatedBorder';
import { useRiseAIMorphIcon } from './hooks/useRiseAIMorphIcon';
import { useAnimatedBorder } from './hooks/useAnimatedBorder';

const BUTTON_BORDER_RADIUS = 9999; // browser clamps to height/2, giving perfect semicircular ends
const PULSE_DELAY = '1.1s';

const pulseGlow = keyframes`
  0%         { box-shadow: 0 2px 8px 0 rgba(146, 104, 247, 0); }
  15%        { box-shadow: 0 2px 8px 0 rgba(146, 104, 247, 0.25); }
  33%        { box-shadow: 0 2px 16px 0 rgba(146, 104, 247, 0.5); }
  50%        { box-shadow: 0 2px 8px 0 rgba(146, 104, 247, 0.25); }
  67%        { box-shadow: 0 2px 16px 0 rgba(146, 104, 247, 0.5); }
  84%, 100%  { box-shadow: 0 2px 8px 0 rgba(146, 104, 247, 0.25); }
`;

const getRiseAiChatButtonSx = theme => ({
  textTransform: 'unset',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  borderColor: 'transparent',
  borderRadius: `${BUTTON_BORDER_RADIUS}px`,
  color: theme.palette.riseAiPurple,
  animation: `${pulseGlow} 3s ease-in-out ${PULSE_DELAY} 1 forwards`,
  '&:hover': {
    borderColor: 'transparent',
    backgroundColor: `${theme.palette.riseAiPurple}10`
  }
});

function NRRiseAIChatButton() {
  const theme = useTheme();
  const [openDrawer, setOpenDrawer] = useState(false);
  const { containerRef, borderDims, borderPerimeter, borderVisible } = useAnimatedBorder();
  const { spinnerComplete, showStaticIcon, handleSpinnerComplete } = useRiseAIMorphIcon();

  return (
    <>
      <Box sx={{ ml: theme.spacing(2), alignSelf: 'center', mt: theme.spacing(-1.25) }}>
        <Box ref={containerRef} sx={{ position: 'relative', display: 'inline-flex' }}>
          <NRRiseAIAnimatedBorder dims={borderDims} perimeter={borderPerimeter} visible={borderVisible} stroke={theme.palette.riseAiPurple} />
          <Button
            sx={getRiseAiChatButtonSx(theme)}
            disableElevation
            variant="outlined"
            startIcon={
              <NRRiseAIMorphIcon
                complete={spinnerComplete}
                showStatic={showStaticIcon}
                onComplete={handleSpinnerComplete}
                color={theme.palette.riseAiPurple}
              />
            }
            onClick={() => setOpenDrawer(true)}
          >
            Chat with RiseAI
          </Button>
        </Box>
      </Box>
      <NRRiseAiChatDrawer open={openDrawer} onClose={() => setOpenDrawer(false)} />
    </>
  );
}

export default NRRiseAIChatButton;
